/**
 * MINI TOURS POR FUNÇÃO — o roteiro curto de UMA função (dica sob demanda).
 *
 * Clique no ponto pulsando, `/tour voz` e o botão da Ajuda chegam aqui. Cada
 * função tem de 1 a 3 passos. Quem está no Hub não tem campo de mensagem, então
 * todo passo que mira a conversa abre uma antes (`garantirConversaAberta`).
 */
import type { ItemDoTour } from '@/stores/guidedTourStore'
import { montarPassos, type Traduzir } from './passos'
import { garantirConversaAberta } from './preparar'
import type { PassoDoTour, RotulosDoTour } from './types'

export interface OpcoesDoItem {
  /** Limpa o `/` digitado pelo passo da lista de comandos. */
  limparCampo: () => void
}

/** Passos do tour completo que o mini tour de equipe reaproveita (sem a lista nem o fecho). */
const PASSOS_DA_EQUIPE = ['engrenagem', 'equipe', 'convidar']

const prepara = () => void garantirConversaAberta()

function passosDeEquipe(t: Traduzir, o: OpcoesDoItem): PassoDoTour[] {
  const todos = montarPassos(t, { podeGerirEquipe: true, temMicrofone: false, limparCampo: o.limparCampo })
  const passos = todos.filter((p) => PASSOS_DA_EQUIPE.includes(p.id))
  // O primeiro balão fala como dica avulsa, não como continuação do tour de boas-vindas.
  return passos.map((p, i) =>
    i === 0 ? { ...p, titulo: t('guidedTour.dicas.equipe.titulo'), texto: t('guidedTour.dicas.equipe.texto') } : p,
  )
}

export function passosDoItem(item: ItemDoTour, t: Traduzir, o: OpcoesDoItem): PassoDoTour[] {
  const dica = (id: string) => ({
    id: `dica-${id}`,
    titulo: t(`guidedTour.dicas.${id}.titulo`),
    texto: t(`guidedTour.dicas.${id}.texto`),
  })
  switch (item) {
    case 'equipe':
      return passosDeEquipe(t, o)
    case 'voz':
      return [{ ...dica('voz'), alvo: '[data-testid="mic-btn"]', lado: 'top', prepara, avanco: { tipo: 'clique' } }]
    case 'comandos':
      return [
        {
          ...dica('comandos'),
          alvo: '[data-testid="chat-input"]',
          lado: 'top',
          prepara,
          avanco: { tipo: 'aparece', seletor: '[role="listbox"]' },
        },
        {
          ...dica('comandos.lista'),
          alvo: '[role="listbox"]',
          lado: 'top',
          avanco: { tipo: 'botao' },
          aoAvancar: o.limparCampo,
        },
      ]
    case 'indicadores':
      return [
        { ...dica('indicadores'), alvo: '[data-testid="indicadores-btn"]', lado: 'top', prepara, avanco: { tipo: 'botao' } },
      ]
  }
}

export function rotulosDoMiniTour(t: Traduzir): RotulosDoTour {
  return {
    proximo: t('guidedTour.botoes.proximo'),
    voltar: t('guidedTour.botoes.voltar'),
    concluir: t('guidedTour.botoes.concluir'),
    progresso: t('guidedTour.botoes.progresso'),
    fechar: t('guidedTour.botoes.fechar'),
  }
}
